export function string2type(type) {
    switch (type) {
        case 'int':
        case 'double':
        case 'long':
        case 'ulong':
            return 'number';
        case 'bool':
            return 'boolean';
        case 'long_array':
        case 'double_array':
        case 'string_array':
        case 'int_array':
        case 'bool_array':
            return 'array';
        case 'string':
            return 'string';
        case 'function':
            return 'function';
        case 'any':
            return 'any';
        case 'any_node':
            return 'any_node';
        default:
            return 'reference';
    }
}
//# sourceMappingURL=helper.js.map